import React from 'react';

const CardOverlay = () => (
  <div
    style={{
      position: 'absolute',
      top: '0px',
      left: '0px',
      right: '0px',
      bottom: '0px',
      backgroundColor: 'rgba(0,0,0,0.5)',
    }}
  />
);

export default CardOverlay;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListGrid/ProjectGridElement/CardOverlay.js